import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GenericService } from '../../generic.service';
import {
  defaultLanguage,
  defaultLanguageCode,
  languages,
} from '../../shared/constants/language.constants';
import { LandingService } from '../service/landing.service';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

type TrainingVideo = {
  id: string;
  titleKey: string;
  urls: Record<string, string>;
  title: string;
  safeUrls?: Record<string, SafeResourceUrl>;
};


@Component({
  selector: 'app-training-maintenance',
  imports: [CommonModule, RouterModule],
  templateUrl: './training-maintenance.component.html',
  styleUrl: './training-maintenance.component.scss'
})
export class TrainingMaintenanceComponent implements OnInit {
  deviceData: any = {};
  deviceData$: any = null;
  qrId: any;
  accountNumber: string = '';

  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  trainingVideos: TrainingVideo[] = [
    {
      id: 'maintenance',
      titleKey: 'maintenance_text',
      urls: {
        en: 'https://www.youtube.com/embed/IMRAp7SznK4?si=tUw6fBvdvFKufR7S',
      },
      title: 'Dump and Fill Troubleshooting - English',
    },
    {
      id: 'troubleshooting',
      titleKey: 'troubleshooting',
      urls: {
        en: 'https://www.youtube.com/embed/F4M5ktHewrI?si=S7bn_8n3On5zvxaO&enablejsapi=1&rel=0',
        es: 'https://www.youtube.com/embed/LPTgu26kxXc?si=YJBNXTDf-bVAQnED&enablejsapi=1&rel=0',
      },
      title: 'Dump and Fill Troubleshooting',
    },
    {
      id: 'prepare',
      titleKey: 'prepare_text',
      urls: {
        en: 'https://www.youtube.com/embed/ZQ_lWYaZEO8?si=FLoql0Vi2K2g1HUO',
        es: 'https://www.youtube.com/embed/H7onJton_EU?si=lAqjk5gfksyK2Lyp',
      },
      title: 'YouTube video player',
    },
    {
      id: 'eht',
      titleKey: 'training_page_EHT',
      urls: {
        en: 'https://www.youtube.com/embed/UJwllQYul2k',
      },
      title: 'YouTube video player',
    },
    {
      id: 'eult_euht',
      titleKey: 'training_page_EULT_EUHT',
      urls: {
        en: 'https://www.youtube.com/embed/XXl3QBRgOl4',
      },
      title: 'YouTube video player',
    },
  ];

  constructor(
    private router: Router,
    private genericService: GenericService,
    private crowdinService: CrowdinService,
    private landingService: LandingService,
    public sanitizer: DomSanitizer,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;

    this.currentLanguage = selectedName;

    this.initializeSafeUrls();

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
  }

  private initializeSafeUrls(): void {
    this.trainingVideos.forEach(video => {
      video.safeUrls = {};

      Object.keys(video.urls).forEach(lang => {
        video.safeUrls![lang] =
          this.sanitizer.bypassSecurityTrustResourceUrl(
            video.urls[lang]
          );
      });
    });
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    this.currentLanguage = selectedLang;
    await this.landingService.loadTranslations(selectedLang);
  }

  get currentLanguageCode(): string {
    return (
      languages.find((lang) => lang.value === this.currentLanguage)?.code ||
      defaultLanguageCode
    );
  }

  navigateHomePage() {
    const accountNumber = this.deviceData?.accountNumber || this.accountNumber;
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.router.navigate([`troubleshoot/${accountNumber}`]);
  }
}
